var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import store from "../../../reduxStore/store";
import { IS_BILLING_ADDRESS, IS_SHIPPING_ADDRESS } from "../../Constant";
import { getLoggedInRepDetailsFromSession } from "../../../services/apiServices/salesRepDataService";
import { createCompanyAction, getSalesRepBaseData } from "../../../reduxStore/actions/salesRepDataAction";
import { useDispatch } from "react-redux";
import { CommonMethods } from "./../CommonMethods";
import isEqual from "lodash/isEqual";
export function AddNewCompanyBL(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var durationTypesOfPayment = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.PaymentTermsTemplates;
    var customerArray = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.customerListWithMainContact;
    var CatalogProductCountList = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.catalogProductList;
    var _e = CommonMethods(), renderAddress = _e.renderAddress, initialFormData = _e.initialFormData, getAddressPayload = _e.getAddressPayload, addressValidationCheckForBilling = _e.addressValidationCheckForBilling, addressValidationCheckForShipping = _e.addressValidationCheckForShipping, getDefaultAddress = _e.getDefaultAddress;
    // Form data
    var _f = useState(initialFormData), formData = _f[0], setFormData = _f[1];
    var originalFormData = useState(initialFormData)[0];
    var _g = useState([]), paymentTermOptions = _g[0], setPaymentTermOptions = _g[1];
    var _h = useState(false), newCustomerModal = _h[0], setNewCustomerModal = _h[1];
    var _j = useState("isShippingAddress"), addressType = _j[0], setAddressType = _j[1];
    var _k = useState(null), catalogHoveredIconIndex = _k[0], setCatalogHoveredIconIndex = _k[1];
    var _l = useState(false), isHovered = _l[0], setIsHovered = _l[1];
    // Address const
    var _m = useState(false), addressModal = _m[0], setAddressModal = _m[1];
    var _o = useState(false), isEditAddressModal = _o[0], setIsEditAddressModal = _o[1];
    var _p = useState({ msg: "", open: false }), triggerSnackbar = _p[0], settriggerSnackbar = _p[1];
    var _q = useState(false), isCreatingCompany = _q[0], setIsCreatingCompany = _q[1];
    var _r = useState(false), allowResetFormData = _r[0], setAllowResetFormData = _r[1];
    useEffect(function () {
        if (durationTypesOfPayment && (durationTypesOfPayment === null || durationTypesOfPayment === void 0 ? void 0 : durationTypesOfPayment.length) > 0) {
            var filteredOptions = durationTypesOfPayment
                .filter(function (item) { return (item === null || item === void 0 ? void 0 : item.paymentTermsType) === "NET" || (item === null || item === void 0 ? void 0 : item.paymentTermsType) === "FULFILLMENT"; })
                .map(function (item) { return (item === null || item === void 0 ? void 0 : item.description) || ""; });
            setPaymentTermOptions(filteredOptions);
        }
    }, [durationTypesOfPayment]);
    var isFormChanged = useMemo(function () {
        return !isEqual(formData, originalFormData);
    }, [formData, originalFormData]);
    // Handle input field changes// ✅ Unified function to update form data dynamically
    var updateFormData = function (key, value) {
        setFormData(function (prevData) {
            var _a;
            return (__assign(__assign({}, prevData), (_a = {}, _a[key] = value, _a)));
        });
    };
    // ✅ Handle input field changes dynamically
    var handleChange = function (e) {
        updateFormData(e.target.name, e.target.value);
    };
    // ✅ Handle checkbox changes
    var handleCheckboxChange = function (e) {
        updateFormData("billingSameAsShipping", e.target.checked);
    };
    // ✅ Handle adding catalog
    var handleCatalogChange = function (event) {
        // change options with real data
        var selectedCatalog = CatalogProductCountList === null || CatalogProductCountList === void 0 ? void 0 : CatalogProductCountList.find(function (catalog) { var _a; return catalog.Id === ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value); });
        if (selectedCatalog && !formData.catalog.some(function (cat) { return cat.Id === selectedCatalog.id; })) {
            updateFormData("catalog", __spreadArray(__spreadArray([], formData.catalog, true), [selectedCatalog], false));
        }
    };
    // ✅ Handle removing catalog
    var handleRemoveCatalog = function (id) {
        var _a;
        updateFormData("catalog", (_a = formData === null || formData === void 0 ? void 0 : formData.catalog) === null || _a === void 0 ? void 0 : _a.filter(function (catalog) { return (catalog === null || catalog === void 0 ? void 0 : catalog.Id) !== id; }));
    };
    // ✅ Handle main contact selection
    var handleMainContactChange = function (customer) {
        setFormData(function (prevData) { return (__assign(__assign({}, prevData), { mainContact: customer === null || customer === void 0 ? void 0 : customer.ClientName, mainContactId: customer === null || customer === void 0 ? void 0 : customer.CustomerId, mainContactEmail: customer === null || customer === void 0 ? void 0 : customer.CustomerMailid })); });
    };
    // ✅ Handle removing main contact
    var handleRemoveMainContact = function () {
        updateFormData("mainContact", "");
        updateFormData("mainContactId", "");
        updateFormData("mainContactEmail", "");
    };
    // Handle form reset
    var handleFormReset = function () { return setFormData(initialFormData); };
    var handleReset = function () {
        if (handleFormReset) {
            handleFormReset();
        }
    };
    // Handle opening modal
    var handleAddressModal = function (type, isEdit) {
        setAddressType(type);
        setAddressModal(true);
        setIsEditAddressModal(isEdit || false);
    };
    // Handle closing modal
    var closeAddressModal = function () {
        setAddressModal(false);
        setIsEditAddressModal(false);
    };
    var handleNewCustomerModal = function () {
        setNewCustomerModal(!newCustomerModal);
    };
    var getCustomerAddressData = function (addressType) {
        if (addressType === IS_SHIPPING_ADDRESS) {
            return renderAddress(formData === null || formData === void 0 ? void 0 : formData.ShippingAddress);
        }
        else if (addressType === IS_BILLING_ADDRESS) {
            return renderAddress(formData === null || formData === void 0 ? void 0 : formData.BillingAddress);
        }
        return (_jsx(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: "No Address Found" })));
    };
    var handleHover = function (state) {
        setIsHovered(state);
    };
    var handleCloseSnackbar = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        settriggerSnackbar({ msg: "", open: false });
    };
    var BackToCompanyPage = function (allow) {
        if (isFormChanged && allow) {
            handleReset();
            props === null || props === void 0 ? void 0 : props.BackBtnHandle();
        }
        else if (isFormChanged) {
            setAllowResetFormData(true);
        }
        else {
            handleReset();
            props === null || props === void 0 ? void 0 : props.BackBtnHandle();
        }
    };
    var getPaymentTerms = function (value) {
        var matchedPaymentTerm = durationTypesOfPayment === null || durationTypesOfPayment === void 0 ? void 0 : durationTypesOfPayment.find(function (term) { return (term === null || term === void 0 ? void 0 : term.description) === value; });
        if (matchedPaymentTerm) {
            return matchedPaymentTerm === null || matchedPaymentTerm === void 0 ? void 0 : matchedPaymentTerm.id;
        }
    };
    var getCompanyLocationName = function (formData) {
        var company = formData.company, ShippingAddress = formData.ShippingAddress;
        if (ShippingAddress && (ShippingAddress === null || ShippingAddress === void 0 ? void 0 : ShippingAddress.address1)) {
            return ShippingAddress === null || ShippingAddress === void 0 ? void 0 : ShippingAddress.address1;
        }
        else if (company) {
            return company;
        }
        else {
            return "";
        }
    };
    var mapCreateCompanyPayload = function (formData) {
        var _a;
        var _b = getLoggedInRepDetailsFromSession(), CustomerId = _b.CustomerId, SalesRepName = _b.SalesRepName; //user credentials
        var repName = SalesRepName;
        var salesRepId = CustomerId;
        // Convert tax settings to boolean
        var isTaxExempt = false;
        if (formData.taxSettings === "Don't Collect Tax") {
            isTaxExempt = true;
        }
        else if (formData.taxSettings === "Collect Tax") {
            isTaxExempt = false;
        }
        return {
            company: {
                name: formData === null || formData === void 0 ? void 0 : formData.company,
                externalId: formData === null || formData === void 0 ? void 0 : formData.companyId,
                note: formData === null || formData === void 0 ? void 0 : formData.companyNote,
            },
            companyLocation: {
                name: getCompanyLocationName(formData),
                note: formData === null || formData === void 0 ? void 0 : formData.companyNote,
                externalId: formData.locationId,
                shippingAddress: (formData === null || formData === void 0 ? void 0 : formData.ShippingAddress) ? getAddressPayload(formData === null || formData === void 0 ? void 0 : formData.ShippingAddress) : {},
                billingAddress: (formData === null || formData === void 0 ? void 0 : formData.BillingAddress) ? getAddressPayload(formData === null || formData === void 0 ? void 0 : formData.BillingAddress) : {},
                billingSameAsShipping: formData.billingSameAsShipping,
                taxExempt: isTaxExempt,
                taxRegistrationId: formData.taxIdField,
                buyerExperienceConfiguration: {
                    paymentTermsTemplateId: (formData === null || formData === void 0 ? void 0 : formData.paymentTerms) ? getPaymentTerms(formData === null || formData === void 0 ? void 0 : formData.paymentTerms) : "",
                },
            },
            companyContact: {
                id: formData.mainContactId ? "gid://shopify/Customer/".concat(formData === null || formData === void 0 ? void 0 : formData.mainContactId) : null,
            },
            catalogIds: ((_a = formData === null || formData === void 0 ? void 0 : formData.catalog) === null || _a === void 0 ? void 0 : _a.map(function (cat) { return cat.Id; })) || [],
            salesRepId: salesRepId,
            salesRepName: repName,
        };
    };
    var handleCreateCompany = function () { return __awaiter(_this, void 0, void 0, function () {
        var payload, resourceNo, result, errMsg, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_a = formData === null || formData === void 0 ? void 0 : formData.company) === null || _a === void 0 ? void 0 : _a.trim())) {
                        settriggerSnackbar({ msg: "Company name is required to create a company.", open: true, severity: "warning" });
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    setIsCreatingCompany(true);
                    payload = mapCreateCompanyPayload(formData);
                    resourceNo = "4";
                    return [4 /*yield*/, createCompanyAction(payload, resourceNo)];
                case 2:
                    result = _c.sent();
                    if (!(result === true)) return [3 /*break*/, 5];
                    settriggerSnackbar({ msg: "Company created successfully!", open: true, severity: "success" });
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 3:
                    _c.sent();
                    return [4 /*yield*/, ((_b = props === null || props === void 0 ? void 0 : props.refreshCompanyList) === null || _b === void 0 ? void 0 : _b.call(props))];
                case 4:
                    _c.sent();
                    setTimeout(function () {
                        handleReset();
                        props === null || props === void 0 ? void 0 : props.BackBtnHandle();
                        setIsCreatingCompany(false);
                    }, 3000);
                    return [3 /*break*/, 6];
                case 5:
                    errMsg = typeof result === "string" ? result : "Failed to create company.";
                    setIsCreatingCompany(false);
                    settriggerSnackbar({ msg: errMsg, open: true, severity: "error" });
                    _c.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_1 = _c.sent();
                    setIsCreatingCompany(false);
                    settriggerSnackbar({ msg: "Unexpected error occurred while creating company.", open: true, severity: "error" });
                    return [3 /*break*/, 9];
                case 8:
                    setTimeout(function () {
                        settriggerSnackbar({ msg: "", open: false });
                    }, 3000);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return {
        t: t,
        formData: formData,
        customerArray: customerArray,
        paymentTermOptions: paymentTermOptions,
        setCatalogHoveredIconIndex: setCatalogHoveredIconIndex,
        catalogHoveredIconIndex: catalogHoveredIconIndex,
        isHovered: isHovered,
        addressModal: addressModal,
        isEditAddressModal: isEditAddressModal,
        handleChange: handleChange,
        handleCatalogChange: handleCatalogChange,
        handleRemoveCatalog: handleRemoveCatalog,
        handleMainContactChange: handleMainContactChange,
        handleRemoveMainContact: handleRemoveMainContact,
        handleReset: handleReset,
        closeAddressModal: closeAddressModal,
        handleNewCustomerModal: handleNewCustomerModal,
        addressValidationCheckForShipping: addressValidationCheckForShipping,
        getCustomerAddressData: getCustomerAddressData,
        handleHover: handleHover,
        handleAddressModal: handleAddressModal,
        handleCheckboxChange: handleCheckboxChange,
        addressValidationCheckForBilling: addressValidationCheckForBilling,
        CatalogProductCountList: CatalogProductCountList,
        addressType: addressType,
        setFormData: setFormData,
        newCustomerModal: newCustomerModal,
        handleCloseSnackbar: handleCloseSnackbar,
        settriggerSnackbar: settriggerSnackbar,
        triggerSnackbar: triggerSnackbar,
        isCreatingCompany: isCreatingCompany,
        handleCreateCompany: handleCreateCompany,
        BackToCompanyPage: BackToCompanyPage,
        isFormChanged: isFormChanged,
        setAllowResetFormData: setAllowResetFormData,
        allowResetFormData: allowResetFormData,
        getDefaultAddress: getDefaultAddress,
    };
}
